import AbstractTranscriptChatFactory from "src/features/transcripts/utils/factory/AbstractTranscriptChatFactory";
class TranscriptChatFactory extends AbstractTranscriptChatFactory {
    create(transcriptStreams) {
        const transcriptChat = this._convertStreamsToChat(transcriptStreams);
        return transcriptChat;
    }
}
export default TranscriptChatFactory;
